import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { RecipientOptionsService, RecipientOptionsUriBuilderParams } from '@app/core/services/recipient-options.service';
import { BaseWithIdList } from '@app/shared/models/list';
import { RecipientOptions } from '@app/shared/models/recipient-options';
import { SearchFilter } from '@app/shared/models/search-filter';
import { ActionListBtnConfig, ActionListOption } from '@app/shared/components/action-list/action-list.component';
import { forkJoin } from 'rxjs';
import { TranslationEntry } from '@app/shared/models/translatable';


@Component({
    templateUrl: './recipient-options-management.component.html',
    styleUrls: ['./recipient-options-management.component.scss']
})
export class RecipientOptionsManagementComponent extends BaseWithBundleComponent
                                                 implements OnInit, OnDestroy {

    public filter: SearchFilter<RecipientOptions>;
    public list: BaseWithIdList<RecipientOptions>;
    public actionListOptions: ActionListBtnConfig<RecipientOptions>[];
    public selected: RecipientOptions;
    public claimNetChannels: TranslationEntry[];

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected recipientOptionsService: RecipientOptionsService) {
        super(componentServiceBundle);
        this._idPrefix = 'settings-recipient-options-management.';
    }

    public ngOnInit() {
        super.ngOnInit();

        this.actionListOptions = [{
            option: ActionListOption.DELETE,
            order: 1
        }];

        this.filter = new SearchFilter(false, false);

        const observables = [
            this.recipientOptionsService.query(new RecipientOptionsUriBuilderParams()),
            this.recipientOptionsService.getClaimNetChannelsAsTranslationEntries()
        ];

        forkJoin(observables).subscribe((results: any) => {
            this.list = results[0];
            this.filter.array = this.list.items;

            if (this.filter.filteredArray.length > 0) {
                this.selected = this.filter.filteredArray[0];
            }

            this.claimNetChannels = results[1];
        }, err => {
            this.handleError(err);
        });
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public create(): void {
        this.selected = null;
        setTimeout(() => {
            this.selected = new RecipientOptions();
        });
    }

    public select(toSelect: RecipientOptions): void {
        if (toSelect) {
            this.selected = null;
            this.recipientOptionsService.getById(this.generateUriBuilderParams(toSelect))
                .subscribe(result => {
                    this.selected = result;
                }, err => this.handleError(err));
        }
    }

    public updateInList(): void {
        if (this.list.getItem(this.selected.id)) {
            this.showSimpleConfirmSnackbar(marker('recipient_options_management.message.recipient_options_updated'));
            this.list.replaceItem(this.selected);
        } else {
            this.showSimpleConfirmSnackbar(marker('recipient_options_management.message.recipient_options_created'));
            this.list.addItem(this.selected);
        }

        this.filter.filter();
    }

    public delete(toDelete: RecipientOptions): void {
        this.recipientOptionsService.delete(this.generateUriBuilderParams(toDelete))
                                    .subscribe(result => {
            this.showSimpleConfirmSnackbar(marker('recipient_options_management.message.recipient_options_deleted'));
            this.list.removeItem(toDelete);
            this.filter.array = this.list.items;

            if (this.selected && this.selected.id === toDelete.id) {
                this.selected = null;
            }
        }, err => this.handleError(err));
    }

    public cancel(): void {
        this.selected = null;
    }

    protected generateUriBuilderParams(entry?: RecipientOptions): RecipientOptionsUriBuilderParams {
        return new RecipientOptionsUriBuilderParams(entry);
    }
}
